import * as React from 'react';
import {
    Grid2, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    IconButton, Typography, Chip, Stack, Divider, Tooltip, Paper, Collapse
} from '@mui/material';

import { KeyboardArrowDown, KeyboardArrowUp, Summarize } from "@mui/icons-material";
import Navbar from '../setup/Navbar'
import HeadingText from '../../BuiltInComponent/HeadingTest'
import DateTimePicker from '../../BuiltInComponent/DateTimePicker';
import ButtonNormal from '../../BuiltInComponent/ButtonNormal';
import Loading from '../../BuiltInComponent/Loading';
// import TableDataWithPagination from '../../BuiltInComponent/TableWithPagination';
import AutoComplete from '../../BuiltInComponent/AutoComplete';
import Footer from '../setup/Footer';
import SalarySheetReportPDF from '../PayrollReports/NewPDFSalarySheet';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { getSalary } from '../../features/PayrollManagement/salarySlice';
import { getUnits } from '../../features/AdminManagement/unitsSlice'

const tableHeadStyle = {
    backgroundColor: '#1E90FF',
    color: 'white',
    textAlign: 'right',
    fontWeight: 'bolder',
    // width: col.width,
    textShadow: 'black 2px 2px 4px',
    cursor: 'pointer'
}
export default function SalarySheet() {

    const dispatch = useDispatch();

    const { isLoading, salarySheet, departments, grandTotals } = useSelector((state) => state.salary);
    const { units } = useSelector((state) => state.units);


    const fmt0 = (n) => (Number.isFinite(+n) ? Number(n).toFixed(0) : "0");
    // const fmt2 = (n) => (Number.isFinite(+n) ? Number(n).toFixed(2) : "0.00");
    const fmtMoney = (n) => new Intl.NumberFormat("en-PK", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(Number.isFinite(+n) ? +n : 0);
    const right = { textAlign: "right", whiteSpace: "nowrap" };

    // --- Which numeric columns to show inside the employee detail grid ---
    const detailCols = [
        { key: "user_pin", label: "PIN", align: "left" },
        { key: "desigName", label: "Designation", align: "left" },
        // { key: "fixedSalary", label: "Fixed?", align: "center", render: (v) => (String(v) === "1" ? "Yes" : "No") },
        // { key: "empOT", label: "OT", align: "center" },
        // { key: "empOTRate", label: "OT Rate", align: "right", render: fmt2 },

        // { key: "working_days_full_month", label: "W.Days (M)", align: "right", render: fmt0 },
        { key: "present_working_days", label: "Present", align: "right", render: fmt0 },
        { key: "late_days", label: "Late", align: "right", render: fmt0 },
        { key: "late_leaves", label: "Late→Leave", align: "right", render: fmt0 },

        { key: "empSalary", label: "Salary", align: "right", render: fmtMoney },
        { key: "per_day_salary", label: "Per Day", align: "right", render: fmtMoney },
        { key: "basic_salary_amount", label: "Basic", align: "right", render: fmtMoney },

        // { key: "overtime_minutes", label: "OT (min)", align: "right", render: fmt0 },
        { key: "overtime_hhmm", label: "OT (HH:MM:SS)", align: "right" },
        { key: "per_hour_base_rate", label: "Base/hr", align: "right", render: fmtMoney },
        { key: "per_hour_ot_rate", label: "OT/hr", align: "right", render: fmtMoney },
        { key: "overtime_amount", label: "OT Amount", align: "right", render: fmtMoney },

        { key: "allowances_amount", label: "Allowances", align: "right", render: fmtMoney },
        { key: "advances_amount", label: "Advances", align: "right", render: fmtMoney },
        { key: "total_pay_gross", label: "Gross", align: "right", render: fmtMoney },
        { key: "total_pay_net", label: "Net", align: "right", render: fmtMoney }
    ];

    // --- Department row with collapsible details ---
    function DeptRow({ dept }) {
        const [open, setOpen] = React.useState(false);
        const t = dept.totals || {};

        return (
            <>
                <TableRow hover sx={{ "& > *": { borderBottom: "unset" } }}>
                    <TableCell padding="none" width={52}>
                        <IconButton size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                        </IconButton>
                    </TableCell>

                    <TableCell>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Typography variant="subtitle1" fontWeight={700}>{dept.deptName}</Typography>
                            <Chip sx={{ background: 'black', color: 'white' }} size="small" label={`${dept.countEmployees} emp`} />
                        </Stack>
                    </TableCell>

                    {/* key department totals (high-level) */}
                    {/* <TableCell sx={right}>{fmt0(t.working_days_full_month)}</TableCell> */}
                    {/* <TableCell sx={right}>{fmt0(t.present_working_days)}</TableCell> */}
                    {/* <TableCell sx={right}>{fmt0(t.late_days)}</TableCell> */}
                    {/* <TableCell sx={right}>{fmt0(t.late_leaves)}</TableCell> */}

                    <TableCell sx={right}>{fmtMoney(t.empSalary)}</TableCell>
                    <TableCell sx={right}>{fmtMoney(t.allowances_amount)}</TableCell>
                    <TableCell sx={right}>{fmtMoney(t.advances_amount)}</TableCell>
                    <TableCell sx={right}>{fmtMoney(t.overtime_amount)}</TableCell>
                    {/* <TableCell sx={right}>{t.overtime_hhmm_total || "00:00:00"}</TableCell> */}
                    <TableCell sx={right}>{fmtMoney(t.total_pay_gross)}</TableCell>
                    <TableCell sx={{ ...right, fontWeight: 700 }}>{fmtMoney(t.total_pay_net)}</TableCell>
                </TableRow>

                {/* Detail: employees table */}
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={13}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box sx={{ p: 1, pl: 7 }}>
                                <Paper variant="outlined" sx={{ overflow: "auto" }}>
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={tableHeadStyle}>Employee</TableCell>
                                                {detailCols.map((c) => (
                                                    <TableCell sx={tableHeadStyle} key={c.key} align={c.align || "left"}>{c.label}</TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {dept.rows.map((r, idx) => (
                                                <TableRow key={r.user_pin ?? idx} hover>
                                                    <TableCell>
                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                            <Typography fontWeight={600}>{r.empName}</Typography>
                                                            {!!r.deptName && (
                                                                <Tooltip title={`Dept: ${r.deptName} • Unit: ${r.unitDescription || "-"}`}>
                                                                    <Summarize fontSize="small" />
                                                                </Tooltip>
                                                            )}
                                                        </Stack>
                                                    </TableCell>
                                                    {detailCols.map((c) => {
                                                        const raw = r[c.key];
                                                        const val = c.render ? c.render(raw) : raw;
                                                        const align = c.align || "left";
                                                        return (
                                                            <TableCell key={c.key} align={align} sx={align === "right" ? right : undefined}>
                                                                {val ?? "-"}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Paper>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </>
        );
    }

    const [rptFilter, setRptFilter] = React.useState({
        fromDate: null,
        toDate: null,
        unitID: null,
    })

    React.useEffect(() => {
        dispatch(getUnits())
    }, [dispatch])

    const onSubmit = async () => {
        const date = new Date(dayjs(rptFilter.fromDate.$d).format('YYYY-MM-DD'));
        const firstDate = new Date(date.getFullYear(), date.getMonth(), 1);

        dispatch(getSalary({
            firstDate: dayjs(firstDate).format('YYYY-MM-DD'),
            fromDate: dayjs(rptFilter.fromDate.$d).format('YYYY-MM-DD'),
            toDate: dayjs(rptFilter.toDate.$d).format('YYYY-MM-DD'),
            unitID: rptFilter.unitID,
            procOrder: 'Salary'
        }))
    }

    // const tableColumns = [
    //     { fieldName: 'unitDescription', cName: 'Unit', textAlign: 'left', width: 80, dType: 'string', status: 'en' },
    //     { fieldName: 'unitDescription', cName: 'Unit', textAlign: 'left', width: 80, dType: 'string', status: 'en' },
    //     { fieldName: 'deptName', cName: 'Dept', textAlign: 'left', width: 80, dType: 'string', status: 'en' },
    //     { fieldName: 'empName', cName: 'Emp Name', textAlign: 'left', width: '5%', dType: 'string', status: 'en' },
    //     // { fieldName: 'working_days_full_month', cName: 'W.Days', textAlign: 'left', width: 80, dType: 'number', status: 'en' },
    //     { fieldName: 'present_working_days', cName: 'W.Days', textAlign: 'left', width: 80, dType: 'number', status: 'en' },
    //     { fieldName: 'late_days', cName: 'L.Count', textAlign: 'left', width: 80, dType: 'number', status: 'en' },
    //     { fieldName: 'late_leaves', cName: 'L.Leaves', textAlign: 'left', width: 80, dType: 'number', status: 'en' },
    //     { fieldName: 'empSalary', cName: 'Salary', textAlign: 'center', width: 80, dType: 'number', status: 'en' },
    //     // { fieldName: 'empOT', cName: 'OT Status', textAlign: 'center', width: 80, dType: 'string', status: 'en' },
    //     { fieldName: 'empOTRate', cName: 'OT Rate', textAlign: 'center', width: 80, dType: 'string', status: 'en' },
    //     { fieldName: 'per_day_salary', cName: 'Per Day', textAlign: 'center', width: 80, dType: 'number', status: 'en' },
    //     { fieldName: 'basic_salary_amount', cName: 'Basic Salary', textAlign: 'center', width: 80, dType: 'number', status: 'en' },
    //     { fieldName: 'overtime_hhmm', cName: 'O.T', textAlign: 'center', width: 80, dType: 'string', status: 'en' },
    //     { fieldName: 'per_hour_ot_rate', cName: 'Per Hour', textAlign: 'center', width: 80, dType: 'number', status: 'en' },
    //     { fieldName: 'overtime_amount', cName: 'O.T.Amt', textAlign: 'center', width: 80, dType: 'number', status: 'en' },
    //     { fieldName: 'total_pay_gross', cName: 'Gross', textAlign: 'center', width: 80, dType: 'number', status: 'en' },
    //     { fieldName: 'allowances_amount', cName: 'Allowances', textAlign: 'center', width: 80, dType: 'number', status: 'en' },
    //     { fieldName: 'advances_amount', cName: 'Advances', textAlign: 'center', width: 80, dType: 'number', status: 'en' },
    //     { fieldName: 'total_pay_net', cName: 'Net Pay', textAlign: 'center', width: 80, dType: 'number', status: 'en' },
    //     { fieldName: 'edit', cName: 'Edit', textAlign: 'center', width: '20%', status: 'dis' },
    //     { fieldName: 'print', cName: 'Print', textAlign: 'center', width: '20%', status: 'dis' },
    //     { fieldName: 'print', cName: 'Print', textAlign: 'center', width: 500, status: 'dis', buttonText: `Individual` },
    // ]

    const handleDeptChange = (data) => {
        const keys = Object.keys(data)
        if (keys[0] === 'unitID') {
            setRptFilter(prev => ({ ...prev, unitID: data[keys] }))
        }
    }

    // const onEditClick = (rowData) => {
    //     console.log("Edit Clicked", rowData);
    // }
    // const onPrintClick = (rowData) => {
    //     console.log("Print Clicked", rowData);
    // }

    const grand = grandTotals || {};
    return (
        <>
            <Navbar />
            <HeadingText text="Salary Sheet Report" />
            <Grid2 container spacing={2} sx={{ p: 2 }}>
                <Grid2 size={2}></Grid2>
                <Grid2 size={2}>
                    <DateTimePicker
                        label='From Date'
                        value={rptFilter.fromDate}
                        onChange={(newDate) => { setRptFilter(prev => ({ ...prev, fromDate: newDate })) }}
                    />
                </Grid2>
                <Grid2 size={2} >
                    <DateTimePicker
                        label='to Date'
                        value={rptFilter.toDate}
                        onChange={(newDate) => { setRptFilter(prev => ({ ...prev, toDate: newDate })) }}
                    />
                </Grid2>
                <Grid2 size={2}>
                    <AutoComplete
                        listData={units}
                        columnName={'unitID'}
                        label={'Units'}
                        value={units.find((c) => c.unitID === rptFilter.unitID)}
                        // value={emp.deptDesc}
                        onChange={handleDeptChange}
                    />

                </Grid2>
                <Grid2 size={2} >
                    <ButtonNormal text="Generate Report" onClick={onSubmit} />
                </Grid2>
                <Grid2 size={2} >

                    <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                        {isLoading ? <Loading /> : <><SalarySheetReportPDF
                            data={salarySheet && salarySheet}
                            title={`Salary Summery Report : ${dayjs(rptFilter.fromDate).format('DD-MMM-YYYY')} - ${dayjs(rptFilter.toDate).format('DD-MMM-YYYY')}`}
                            company="Maltex Exports"
                            fileName={`Salary Summery Report : ${dayjs(rptFilter.fromDate).format('DD-MMM-YYYY')} - ${dayjs(rptFilter.toDate).format('DD-MMM-YYYY')}`}
                            reportDate={dayjs(new Date()).format('DD-MMM-YYYY')}
                            label="Print Report" />
                        </>
                        }
                    </Box>
                </Grid2>
                <Grid2 size={2}></Grid2>
            </Grid2>
            {
                isLoading ?
                    <>
                        <Loading />
                    </>
                    :
                    departments && departments.length > 0 ?
                        <>
                            <Box sx={{ p: 2 }}>
                                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                                    <Typography variant="h6" fontWeight={800}>Department-wise Payroll</Typography>
                                    <Typography variant="body2" color="text.secondary" >
                                        Rows: {departments && departments.reduce((s, d) => s + (d?.rows?.length || 0), 0)}
                                    </Typography>
                                </Stack>

                                <TableContainer component={Paper} sx={{
                                    // maxHeight: 640,
                                    overflow: "auto",
                                    "& thead th": { position: "sticky", top: 0, zIndex: 1 }
                                }}>
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={[tableHeadStyle, { textAlign: 'left' }]} width={52} />
                                                <TableCell sx={[tableHeadStyle, { textAlign: 'left' }]}>Department</TableCell>
                                                {/* <TableCell align="right">W.Days (M)</TableCell> */}
                                                {/* <TableCell align="right">Present</TableCell> */}
                                                {/* <TableCell align="right">Late</TableCell> */}
                                                {/* <TableCell align="right">Late→Leave</TableCell> */}

                                                <TableCell sx={[tableHeadStyle, { textAlign: 'center' }]}>Salary</TableCell>
                                                <TableCell sx={[tableHeadStyle, { textAlign: 'center' }]}>Allowances</TableCell>
                                                <TableCell sx={[tableHeadStyle, { textAlign: 'center' }]}>Advances</TableCell>
                                                <TableCell sx={[tableHeadStyle, { textAlign: 'center' }]}>OT Amount</TableCell>
                                                {/* <TableCell align="right">OT (HH:MM:SS)</TableCell> */}
                                                <TableCell sx={[tableHeadStyle, { textAlign: 'center' }]}>Gross</TableCell>
                                                <TableCell sx={[tableHeadStyle, { textAlign: 'center' }]}><b>Net</b></TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {departments && departments.map((dept) => (
                                                <DeptRow key={dept.deptName} dept={dept} />
                                            ))}

                                            {/* Grand Totals row */}
                                            <TableRow>
                                                <TableCell />
                                                <TableCell>
                                                    <Typography fontWeight={900}>GRAND TOTAL</Typography>
                                                </TableCell>

                                                {/* <TableCell sx={right}>{fmt0(grand.working_days_full_month)}</TableCell> */}
                                                {/* <TableCell sx={right}>{fmt0(grand.present_working_days)}</TableCell> */}
                                                {/* <TableCell sx={right}>{fmt0(grand.late_days)}</TableCell> */}
                                                {/* <TableCell sx={right}>{fmt0(grand.late_leaves)}</TableCell> */}

                                                <TableCell sx={right}>{fmtMoney(grand.empSalary)}</TableCell>
                                                <TableCell sx={right}>{fmtMoney(grand.allowances_amount)}</TableCell>
                                                <TableCell sx={right}>{fmtMoney(grand.advances_amount)}</TableCell>
                                                <TableCell sx={right}>{fmtMoney(grand.overtime_amount)}</TableCell>
                                                {/* <TableCell sx={right}>{grand.overtime_hhmm_total || "00:00:00"}</TableCell> */}
                                                <TableCell sx={right}>{fmtMoney(grand.total_pay_gross)}</TableCell>
                                                <TableCell sx={{ ...right, fontWeight: 900 }}>{fmtMoney(grand.total_pay_net)}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <Divider sx={{ my: 1.5 }} />
                                <Typography variant="caption" color="text.secondary">
                                    Tip: Department row par arrow se expand karke employees ki detail dekhein.
                                </Typography>
                            </Box>
                            {/* 
                            <Box style={{ marginLeft: 20, marginRight: 20 }}>
                                <TableDataWithPagination tableColumns={tableColumns} tableData={salarySheet && salarySheet}
                                    onEditClick={onEditClick} onButtonClick={onPrintClick} perPage={50} />
                            </Box> */}

                        </>
                        : <><HeadingText text="Data Not Found!..." /></>
            }
            {/* {
                isLoading ?
                    <>
                        <Loading />
                    </>
                    :
                    salarySheet.length > 0 ?
                        <>
                        </>
                        : <><HeadingText text="Data Not Found!..." /></>
            } */}
            <Footer />

        </>
    );
}